import React from "react";
import {
  FaFacebook,
  FaInstagram
} from "react-icons/fa";
import { SlSocialGoogle } from "react-icons/sl";
import { FaXTwitter } from "react-icons/fa6";


import { Link } from "react-router-dom";
import { footerContent } from "../content/common/footerContent";

const iconMap: any = {
  twitter: FaXTwitter,
  facebook: FaFacebook,
  google: SlSocialGoogle,
  telegram: FaInstagram,
};

const Footer: React.FC = () => {
  const { logo, companyInfo, sitemap, socialLinks, copyright } =
    footerContent;

  return (
    <footer className="bg-gray-900 text-gray-400 py-12">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-8">

        {/* LEFT */}
        <div>
          <h3 className="text-white font-bold text-lg mb-3 flex items-center">
            <img src={logo} alt="ARSH Logo" className="h-14 mr-2" />
          </h3>

          <p className="text-sm whitespace-pre-line">
            {companyInfo.description}
          </p>

          {/* Social Icons */}
          {/* UNCOMMENT BELOW LATER */}
          {/* <div className="flex gap-4 mt-4">
            {socialLinks.map((item, index) => {
              const Icon = iconMap[item.name];
              return (
                <a key={index} href={item.url} target="_blank">
                  <Icon className="text-lg hover:text-white transition" />
                </a>
              );
            })}
          </div> */}
        </div>

        {/* RIGHT */}
        <div>
          <h4
            className="text-white font-normal mb-3 text-[35px]"
            style={{ fontFamily: "Roboto Serif" }}
          >
            {sitemap.title}
          </h4>

          <ul className="text-sm space-y-1">
            {sitemap.links.map((link, index) => (
              <li key={index}>
                <Link to={link.path} className="hover:text-white">
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>


    </footer>
  );
};

export default Footer;